import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import SectionContainer from '@common/components/SectionContainer';
import { token } from 'odyssey';

export const NotFoundWrapper = styled.div`
  padding: 20px;
  background: #f7f7f7;
  border: 1px solid #e2e2e2;
  border-radius: 5px;
  max-width: 560px;
  text-align: center;
  margin: 30px auto;
  line-height: 26px;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-weight: bold;
`;

export const SectionDescription = styled.div`
  display: none;
  max-width: 560px;
  line-height: 26px;
  margin: 0;
  color: ${({ theme }) => theme.defaultColors.fontSecondary};

  ${media.md`
    display: block;
  `}
`;

export const PageTitleDescriptionWrapper = styled.div`
  padding-top: 40px;
  margin-bottom: 20px;
`;

export const ShowMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 0;
`;

export const BackgroundWrapper = styled.div`
  position: relative;
  z-index: 10;

  > div {
    ${media.md`
      margin-bottom: 0px;
    `}

    display: grid;

    > div {
      display: grid;

      > div {
        display: grid;
        place-items: center;
      }
    }
  }

  ${media.md`
    margin-bottom: 0
  `}
`;

export const BannerContentsWrapper = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 0;

  ${media.sm`
  padding: 0rem 1rem 0rem 1rem;
  `}

  ${media.md`
    padding: 4rem 1rem;
    min-height: 500px;
  `}
`;

export const TitleContent = styled.div`
  max-width: 700px;
`;

export const StyledHero = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  backdrop-filter: brightness(0.75);
  color: ${token('color-white')};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export const SolidColorBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${({ theme }) => theme.tertiaryColour};
  opacity: 0.8;
  min-height: 300px;
`;

export const StyledSectionContainer = styled(SectionContainer)``;

export const BannerTitle = styled.h1`
  font-size: ${token('heading-1-hero-mb-font-size')};
  color: ${token('color-white')};
  text-shadow: 0px 3px 20px #000000;
  text-align: center;
  margin-top: 0;
  margin-bottom: 36px;

  ${media.md`
    font-size: ${token('heading-1-hero-dt-font-size')};
    text-align: center;
  `};
`;
